var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"date-input",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":_vm._value},on:{"click":function($event){return _vm.$emit('click')},"blur":function($event){return _vm.$emit('blur')},"paste":_vm.handlePaste}})
}
var staticRenderFns = []

export { render, staticRenderFns }